import { materialRenderers } from '@jsonforms/material-renderers';
import PassportPhotoControl, { passportPhotoControlTester } from '../components/fields/JSONForms/PassportPhotoControl';
export const jsonFormsMaterialRenderers = [
    ...materialRenderers,
    { tester: passportPhotoControlTester, renderer: PassportPhotoControl },
];
